export const objectiveUtil = {
  url: (ref: string) => `${window.location.origin}/objective/${ref}`,
};
